<template>
  <div class="loginbg">
    <b-form @submit="sumbit">
      <img class="logo" src="../assets/logo.png" alt />
      <b-form-group>
        <b-form-input id="input-1"
                      v-model="form.account"
                      required
                      placeholder="ID"></b-form-input>
      </b-form-group>
      <b-form-group>
        <b-form-input id="input-1"
                      v-model="form.password"
                      type="password"
                      required
                      placeholder="Password"></b-form-input>
      </b-form-group>
      <b-form-group v-if="showcode">
        <b-form-input id="input-1"
                      v-model="form.code"
                      required
                      placeholder="驗證碼"></b-form-input>
        <div @click="refreshCode">
          <Sidentify :identifyCode="identifyCode"></Sidentify>
        </div>
      </b-form-group>
      <b-form-group>
        <b-form-radio-group v-model="selected"
                            :options="options"
                            name="radio-inline"
                            id="ccheckbox"></b-form-radio-group>
      </b-form-group>
      <b-form-group style="text-align: center">
        <b-button type="sumbit" class="loginbtn">Login</b-button>
      </b-form-group>
    </b-form>
  </div>
</template>

<script>
  import qs from "qs";
  import { isMobile } from "mobile-device-detect";
  import Sidentify from "../components/identify";
  export default {
    components: { Sidentify },
    data() {
      return {
        checkresult: false,
        identifyKey: "",
        identifyCode: "",
        showcode: false,
        form: {
          account: "",
          password: "",
          code: "",
        },
        selected: "staff",
        options: [
          { text: "員工", value: "staff" },
          { text: "推廣大使", value: "staff2" },
        ],
      };
    },
    created() {
      //是否為tutorChat登入
      var token = this.$route.query.token;
      if (token != "" && token != undefined) {
        this.tutorChatLogin(token);
      }

      //this.autoLogin();
    },
    mounted() {
      this.identifyCode = "";
      this.makeCode(this.identifyCodes, 4);
    },
    methods: {
      randomNum(min, max) {
        return Math.floor(Math.random() * (max - min) + min);
      },

      refreshCode() {
        this.identifyCode = "";
        this.makeCode(this.identifyCodes, 4);
      },
      makeCode(o, l) {
        if (this.showcode) return;

        var that = this;
        this.$axios
          .post("SCRMApp/MakeCode")
          .then(function (response) {
            that.identifyCode = response.data.code;
            that.identifyKey = response.data.key;
          })
          .catch(function (error) {
            console.log(error);
          });
      },
      //autoLogin() {
      //  var ticket = this.GetTicket();
      //  if (ticket !== null) {
      //    var that = this;
      //    this.$axios
      //      .post(
      //        "SCRMApp/TicketAesDecrypt",
      //        qs.stringify({
      //          ticket: ticket,
      //        })
      //      )
      //      .then(function (response) {
      //        var result = response.data;
      //        that.form.account = result.Account;
      //        that.form.password = result.Password;
      //        that.selected = result.IsStaff ? "staff" : "staff2";
      //
      //        that.login();
      //      })
      //      .catch(function (error) {
      //        console.log(error);
      //      });
      //  }
      //},
      saveticket(scrmTicket) {
        var exdate = new Date();
        var expirems = 1000 * 60 * 60 * 24 * 30;
        exdate.setTime(exdate.getTime() + expirems);

        document.cookie =
          "scrmticket" +
          "=" +
          escape(scrmTicket) +
          ";expires=" +
          exdate.toGMTString() +
          "; path=/";
      },
      savestaff(staff) {
        var value = JSON.stringify(staff);
        var exdate = new Date();
        var expirems = 1000 * 60 * 60 * 24 * 30;
        exdate.setTime(exdate.getTime() + expirems);

        document.cookie =
          "scrmstaff" +
          "=" +
          escape(value) +
          ";expires=" +
          exdate.toGMTString() +
          ";";
        //" domain=.tutorabc.com;path=/";
      },
      tutorChatLogin(token) {
        let vm = this;

        vm.$axios
          .post(
            "SCRMApp/GetTutorChatTokenModel",
            qs.stringify({
              tutorChatToken: token,
            })
          )
          .then(function (response) {
            var result = response.data;
            if (result.Success) {
              var staff = {
                staffsn: result.Result.StaffSn,
                userid: result.Result.Account,
                staffid: result.Result.StaffId,
                isstaff: !result.Result.IsSalesAgent,
              };

              vm.savestaff(staff);
              vm.gotoSCRM();
            } else {
              alert(result.DisplayMessage);
            }
          })
          .catch(function (error) {
            console.log(error);
          });
      },
      sumbit(evt) {
        evt.preventDefault();
        this.login();
      },
      async checkCode() {
        let vm = this;
        return await vm.$axios
          .post(
            "SCRMApp/CheckCode",
            qs.stringify({
              key: vm.identifyKey,
              code: vm.form.code,
            })
          )
          .then(function (response) {
            return response.data;
          })
          .catch(function (error) {
            console.log(error);
          });
      },
      async login() {
        let vm = this;

        if (vm.showcode) {
          let checkresult = await vm.checkCode();

          if (!checkresult) {
            alert("驗證碼錯誤");
            vm.makeCode();
            return;
          }
        }

        var isstaff = this.selected == "staff";

        vm.$axios
          .post(
            "SCRMApp/Login",
            qs.stringify({
              UserId: vm.form.account,
              Passwords: vm.form.password,
              IsStaff: isstaff,
            })
          )
          .then(function (response) {
            var result = response.data;
            if (result.Success) {
              var staff = {
                staffsn: result.Result.staff.StaffSn.toString(),
                userid: result.Result.userId,
                staffid: result.Result.staff.id,
                isstaff: isstaff,
              };
              vm.savestaff(staff);
              vm.saveticket(result.Result.scrmTicket);
              vm.gotoSCRM();
            } else {
              var exp = new Date();
              exp.setTime(exp.getTime() - 1);
              document.cookie =
                "scrmstaff" + "=" + "" + ";expires=" + exp.toGMTString();
              document.cookie =
                "scrmticket" + "=" + "" + ";expires=" + exp.toGMTString();
              alert(result.DisplayMessage);
            }
          })
          .catch(function (error) {
            console.log(error);
          });
      },
      gotoSCRM: function () {
        let vm = this;
        vm.$axios
          .post(
            "SCRMApp/GetLoginDirectURL",
            qs.stringify({
              isMobile: isMobile,
            })
          )
          .then(function (response) {
            window.location.href = response.data;
          })
          .catch(function (error) {
            console.log(error);
          });
      },
    },
    computed: {},
  };
</script>

<style scoped>
  .loginbg {
    background: rgba(131, 19, 19, 1);
    background: -moz-linear-gradient( top, rgba(131, 19, 19, 1) 20%, rgba(228, 28, 29, 1) 100% );
    background: -webkit-gradient( left top, left bottom, color-stop(20%, rgba(131, 19, 19, 1)), color-stop(100%, rgba(228, 28, 29, 1)) );
    background: -webkit-linear-gradient( top, rgba(131, 19, 19, 1) 20%, rgba(228, 28, 29, 1) 100% );
    background: -o-linear-gradient( top, rgba(131, 19, 19, 1) 20%, rgba(228, 28, 29, 1) 100% );
    background: -ms-linear-gradient( top, rgba(131, 19, 19, 1) 20%, rgba(228, 28, 29, 1) 100% );
    background: linear-gradient( to bottom, rgba(131, 19, 19, 1) 20%, rgba(228, 28, 29, 1) 100% );
    filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#831313', endColorstr='#e41c1d', GradientType=0 );
    height: 100%;
    position: relative;
  }

  .logo {
    width: 190px;
    margin: 0 auto 60px;
    display: block;
  }

  .form-control {
    background: rgba(174, 35, 35, 1);
    border: none;
    border-radius: 30px;
    padding: 25px 20px;
    font-size: 15px;
    color: #fff;
  }

    .form-control:focus {
      box-shadow: none;
    }

    .form-control::placeholder {
      color: #c95757;
    }

  form {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -95%);
    width: 80%;
    height: 200px;
    max-width: 290px;
  }

  .loginbtn {
    background-color: #5b1919;
    color: #db8585;
    font-size: 16px;
    border-radius: 30px;
    width: 100%;
    border: none;
    padding: 13px;
    box-shadow: 0 5px 10px 0 rgba(0, 0, 0, 0.1);
  }

  form .custom-control-label span {
    color: #de6969;
    font-size: 13px;
  }
</style>



// WEBPACK FOOTER //
// src/views/Login.vue